import { all, fork, put, select, takeLatest } from 'redux-saga/effects';
import { getTransactions, ACTION_REQUEST_TRANSACTION, getCategoriesAPI } from './index';

function* loadRouteData() {
  const { transaction } = yield select();
  const { transactionFilter } = transaction;
  yield put(getTransactions(transactionFilter));
}

function* handleListenActions() {
  yield takeLatest([ACTION_REQUEST_TRANSACTION], function* () {
    const { transaction } = yield select();
    const { transactionFilter, category } = transaction;
    yield put(getTransactions(transactionFilter));
    yield put(getCategoriesAPI());
  });
}

export function* loadTransactionPage() {
  yield all([fork(loadRouteData), fork(handleListenActions)]);
}
